import { Request } from '../../../httpClient/serverApi/requests/Request';
import { IGetItemsParams } from '../../../httpClient/serverApi/types/IGetItemsParams';
import { IGetItemsResult } from '../../../httpClient/serverApi/types/IGetItemsResult';
import { IUser } from '../../../userManagement/users/serverApi/types/IUser';

export interface IGetUsersForDataAlertParams extends IGetItemsParams {
  dataAlertId: string;
}

export interface IGetUsersForDataAlertResult extends IGetItemsResult {
  users: IUser[];
}

export class GetUsersForDataAlertRequest extends Request<IGetItemsParams, IGetUsersForDataAlertResult> {
  constructor(params: IGetUsersForDataAlertParams) {
    super('getUsersForDataAlert', params);
  }
}
